import apiService from '@/utils/request';

const URIs = {
  errors: '/v1/errors'
};

export function enviarEmail(payload) {
  return apiService.post(URIs.errors, payload);
}
